import { ReactComponent as TriangleVideoIcon } from "../../assets/icons/triangle-video.svg";
import style from "../block.module.scss";
const MiniVideo = ({ video, handleClick }) => {
  return (
    <div onClick={handleClick} className={style.miniVideo}>
      <div>
        <img src={video.thumbnail.url} alt={video.thumbnail.alt} />
        <TriangleVideoIcon className={style.icon} />
      </div>
      <p>{video.title}</p>
    </div>
  );
};

export default MiniVideo;
